import React from 'react';
import Logo from './Logo';

/**
 * Wordmark wrapper — inner span sizes the raster; outer click target lives on parent div.
 */
export default function OrivonLogo({ height = 38, className, style, alt = 'OrivonAI' }) {
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        width: 'max-content',
        ...style,
      }}
    >
      <Logo height={height} aria-label={alt} />
    </span>
  );
}
